var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermalHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.79,
    height: 12.52,
    viewBox: "0 0 16.79 12.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.79,12.52H0V0H16.79V12.52ZM.62,11.9h15.55V.62H.62V11.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.09,2.14h0c-.68,0-1.23,.55-1.23,1.23v5.78c0,.68,.55,1.23,1.23,1.23h0c.68,0,1.23-.55,1.23-1.23V3.37c0-.68-.55-1.23-1.23-1.23Zm.85,7c0,.47-.38,.85-.85,.85h0c-.47,0-.85-.38-.85-.85v-1.39h.27c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.27v-.29h.15c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.15v-.29h.27c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.27v-.29h.15c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.15v-.29h.27c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.27v-.29h.15c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.15v-.29h.27c.06,0,.11-.05,.11-.11s-.05-.11-.11-.11h-.27v-1.05c0-.47,.38-.85,.85-.85h0c.47,0,.85,.38,.85,.85v5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.28,8.5V3.52c0-.1-.09-.19-.19-.19h0c-.1,0-.19,.08-.19,.19v4.98c-.15,.07-.26,.23-.26,.41,0,.25,.2,.45,.45,.45s.45-.2,.45-.45c0-.18-.11-.34-.26-.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.41,8.58c-.2-.19-.36-.41-.45-.67-.06-.18-.04-.35,.04-.52,.08-.19,.18-.38,.26-.58,.05-.13,.08-.27,.11-.41,.04-.17,.01-.33-.07-.49,.24,.07,.45,.33,.48,.58,.02,.26-.03,.5-.13,.73-.05,.12-.1,.23-.17,.34-.18,.3-.2,.61-.09,.93,.01,.03,.02,.07,.03,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.68,4.04c.29,.1,.47,.35,.48,.63,.01,.24-.04,.47-.14,.69-.05,.11-.1,.22-.16,.33-.19,.3-.2,.61-.09,.94,.01,.03,.02,.06,.03,.09v.02c-.24-.3-.51-.57-.46-.98,.02-.16,.1-.31,.16-.47,.07-.17,.15-.33,.21-.51,.08-.24,.12-.49-.02-.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermalHot);
export default __webpack_public_path__ + "static/media/ThermalHot.16dbcb983a735bbb09ee189ec6fc211c.svg";
export { ForwardRef as ReactComponent };